import { AdditionalInterestAndInsured } from 'src/configs/APISchemas/Application.schema';
import { InterestedParty } from 'src/pages/payment-msi/PaymentMsiV2/types';

const FallbackValues = {
  FallbackFirstName: '',
  FallbackLastName: '.',
} as const;

export const mapInterestedPartyToAdditionalInterests = (
  interestedParty: InterestedParty,
): AdditionalInterestAndInsured[] => {
  const interestedPartyFistName =
    interestedParty.fullName.split(' ')[0] ?? FallbackValues.FallbackFirstName;
  const interestedPartyLastName =
    interestedParty.fullName.split(' ')[1] ?? FallbackValues.FallbackLastName;

  return [
    {
      firstName: interestedPartyFistName,
      lastName: interestedPartyLastName,
      email: interestedParty.email,
    },
  ];
};
